import { Component } from '@angular/core';

@Component({
  selector: 'peca-shipping-loader',
  templateUrl: './shipping-loader.component.html',
  styleUrl: './shipping-loader.component.scss',
  imports: [],
})
export class ShippingLoaderComponent {}
